import type { RouteRecordRaw } from 'vue-router';
import headerRoutes from '@/modules/header/header.routes.children';
import { prefixRouteNames } from '@/shared/utils/routes';

export default [
    {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('./components/DashboardContent.vue'),
        meta: {
            title: 'Dashboard',
            sideNav: {
                key: 'dashboard',
            }
        },
        children: [
            {
                path: 'new-workspace',
                name: 'new-workspace',
                component: () => import('./components/modals/NewWorkspace.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'delete-workspace/:workspaceId',
                name: 'delete-workspace',
                component: () => import('./components/modals/DeleteWorkspace.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'edit-workspace/:workspaceId',
                name: 'edit-workspace',
                component: () => import('./components/modals/EditWorkspace.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'duplicate-workspace/:workspaceId',
                name: 'duplicate-workspace',
                component: () => import('./components/modals/DuplicateWorkspace.vue'),
                meta: {
                    modal: true,
                },
                beforeEnter: (to, from, next) => {
                    return from.name === 'dashboard' ? next() : next({
                        name: 'dashboard', params: to.params
                    });
                },
            },
            {
                path: 'new-workspace-group',
                name: 'new-workspace-group',
                component: () => import('./components/modals/NewWorkspaceGroup.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'add-workspace-to-group/:workspaceId',
                name: 'add-workspace-to-group',
                component: () => import('./components/modals/AddToWorkspaceGroup.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'ungroup-workspaces/:workspaceGroupId',
                name: 'ungroup-workspaces',
                component: () => import('./components/modals/UngroupWorkspaces.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'edit-workspace-group/:workspaceGroupId',
                name: 'edit-workspace-group',
                component: () => import('./components/modals/EditGroupWorkspace.vue'),
                meta: {
                    modal: true,
                },
            },
            {
                path: 'news',
                name: 'news',
                component: () => import('../header/components/modals/News/NewsModal.vue'),
                meta: {
                    modal: true,
                },
                props: (route) => {
                    return {
                        link: route.query.link,
                        showCheckbox: route.query.showCheckbox !== 'false',
                    };
                },
            },
            ...prefixRouteNames('dashboard', headerRoutes),
        ],
    },
] satisfies RouteRecordRaw[];
